export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Währung"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bericht erstellen"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Währungsergebnis"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Herunterladen"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blatt"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erlaubtes Dateiformat - xlsx"])}
}